export const ToolkitConstants = {
    MACHINENAME_IMAGE: "field_media_image",
    MACHINENAME_VIDEO: "field_media_video_file",
    MACHINENAME_AUDIO: "field_media_audio_file",
    MACHINENAME_DOCUMENT: "field_media_document",
    MACHINENAME_TYPE_REMOTE_VIDEO: "media--remote_video",
    MACHINENAME_REMOTE_VIDEO: "field_media_oembed_video",
    MACHINENAME_METATAG: "metatag",
    MACHINENAME_METATAG_PREFIX: "meta",
};
export const Errors = {
    DTK000001: { code: "DTK000001", message: "Something is not right." },
    DTK001001: { code: "DTK001001", message: "Failed to fetch content meta." },
    DTK001002: { code: "DTK001002", message: "Failed to fetch content." },
    DTK001003: { code: "DTK001003", message: "Failed to fetch menu." },
    DTK002001: { code: "DTK002001", message: "Auth Config is missing." },
    DTK002002: { code: "DTK002002", message: "Server Config is missing." },
    DTK002003: { code: "DTK002003", message: "Content Config is missing." },
    DTK002004: {
        code: "DTK002004",
        message: "Static Content Config is missing.",
    },
    DTK002005: {
        code: "DTK002005",
        message: "Preview ID or PreviewerID can't be falsy when isPreview is set",
    },
    DTK002006: {
        code: "DTK002006",
        message: "Offset or limit can't be falsy when pagination is set",
    },
};
